<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-btn
      color="primary"
      class="text-capitalize"
      block
      rounded
      @click="$emit('update:status', yachtStatuses.INVESTMENT_STATUS_RESERVED)"
    >
      <v-icon
        left
        small
      >
        arrow_forward
      </v-icon>
      Mark as Reserved
    </v-btn>
  </div>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'Approved',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        yachtStatuses: Yacht
      }
    }
  }
</script>

<style scoped>

</style>
